import {
  Canvas,
  FabricImage,
  FabricObject,
  IText,
  Rect,
  Line,
  Group,
  Pattern,
  util,
} from 'fabric';

// Persist gang-sheet metadata through toJSON / loadFromJSON
FabricObject.customProperties = [
  ...(FabricObject.customProperties || []),
  'designMeta',
  'isGangDesign',
];

export const fabric = {
  Canvas,
  Image: FabricImage,
  IText,
  Rect,
  Line,
  Group,
  Pattern,
  util,
};
